import { PersonalDetailsWithFullName } from './personal-details-with-full-name';

export interface PersonalizationPerson<T = string, U = Date> extends PersonalDetailsWithFullName<T, U> {
  isUser: boolean;
}
